export default {
  title: 'ASAP SETTINGS',
  items: {
    UseOldAsap: {
      label: 'Use Old Asap',
      type: 'string',
      unit: ''
    },
    ConsumerAppAllowLAXSharedASAP: {
      label: 'Consumer App allow LAX Shared',
      type: 'boolean'
    },
    ConsumerAppAllowNonLAXSharedASAP: {
      label: 'Consumer App allow Non-LAX Shared',
      type: 'boolean'
    },
    ASAPNoDriverIncentiveCode: {
      label: 'No Driver - Incentive CODE',
      type: 'string',
      unit: ''
    }
  }
}
  


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/asap-availability.js